import { handleError as d } from "../js/request-zRag5cDd.js";
import { arrayToMap as g } from "../utils/utils.js";
import { useQuery as h } from "@tanstack/react-query";
import { useRef as M, useMemo as m } from "react";
const l = {}, f = (t, n, r) => {
  const { getLabel: o, getValue: e, sort: s = !0 } = n || {};
  return m(() => {
    if (!o || !e || !t)
      return [];
    const u = t.map((a) => ({
      label: o(a),
      value: e(a)
    }));
    return s && u.sort((a, i) => a.label.toLowerCase().localeCompare(i.label.toLowerCase())), r?.includeNoneOption && n?.noneOption && u.unshift(n.noneOption), u;
  }, [t, o, e, s, r, n?.noneOption]);
}, b = (t, n) => {
  const { getKey: r, getValue: o } = n ?? {};
  return m(() => !r || !t ? {} : g(t, r, o), [t, r, o]);
}, A = (t, n, r, o) => {
  if (r?.aborted)
    throw t;
  if (!o?.ignoreError?.(t)) {
    const e = o?.errorMessage ?? n.errorMessage;
    d(t, {
      displayToast: !!e,
      toastMessage: e
    });
  }
  return !1;
}, p = (t, n, r, o, e, s) => {
  const { disabled: u } = e, a = M(), i = [...t, r];
  return h({
    queryKey: i,
    queryFn: (c) => (a.current = c.signal, n(r, c.signal).then((y) => {
      if (a?.current?.aborted)
        throw new Error("Fetch Aborted");
      return y;
    })),
    throwOnError: (c) => A(c, s, a?.current, e),
    enabled: !u && !o,
    refetchOnMount: e?.refetchOnMount,
    retry: (c, y) => y?.status === 404 ? !1 : c < 4,
    refetchOnWindowFocus: !1
  });
}, w = (t, n, r) => (o, e = l) => p(t, n, o ?? 0, !o, e, r), E = (t, n, r) => (o, e = l) => p(
  t,
  n,
  o ?? new Array(),
  !o || o.some((s) => !s),
  e,
  r
), T = (t, n, r) => {
  const o = (e) => r.disable ? r.disable(e) : !1;
  return (e, s = l) => p(
    t,
    n,
    e,
    o(e),
    s,
    r
  );
}, k = (t, n, r) => (o = l, e = l) => {
  const s = p(
    t,
    (c, y) => n(y),
    void 0,
    !1,
    o,
    r
  ), u = Array.isArray(s.data) ? s.data : void 0, a = b(u, r.parseToMap), i = f(
    u,
    r.parseToOptions,
    e
  );
  return { ...s, map: a, options: i };
}, H = (t, n, r) => {
  const o = (e) => r.disable ? r.disable(e) : !1;
  return (e = l, s = l, u = l) => {
    const a = p(
      t,
      n,
      e,
      o(e),
      s,
      r
    ), i = b(a.data, r.parseToMap), c = f(
      a.data,
      r.parseToOptions,
      u
    );
    return { ...a, map: i, options: c };
  };
}, L = {
  getByIdHook: w,
  getByIdsHook: E,
  searchParamsHook: H,
  regularHook: T,
  noParamsHook: k
};
export {
  L as default
};
//# sourceMappingURL=HookBuilder.js.map
